(function () {
  'use strict';

  function toArray(value) {
    return Array.prototype.slice.call(value);
  }

  function getSlides(slider) {
    return toArray(slider.children).filter(function (child) {
      return !child.classList.contains('content-slider__arrow') && !child.classList.contains('content-slider__dots');
    });
  }

  function currentIndex(slider, slides) {
    if (!slides.length) return 0;
    var sliderRect = slider.getBoundingClientRect();
    var closestIndex = 0;
    var closestDistance = Infinity;

    slides.forEach(function (slide, index) {
      var distance = Math.abs(slide.getBoundingClientRect().left - sliderRect.left);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function scrollToSlide(slider, slides, index) {
    var slide = slides[index];
    if (!slide) return;
    slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
  }

  function initContentSlider(slider) {
    if (slider.dataset.contentSliderReady === 'true') return;

    var slides = getSlides(slider);
    if (slides.length <= 1) return;

    slider.dataset.contentSliderReady = 'true';
    slider.setAttribute('role', 'region');
    slider.setAttribute('aria-roledescription', 'carousel');

    var shell = slider.closest('.content-slider-shell');
    if (!shell) {
      shell = document.createElement('div');
      shell.className = 'content-slider-shell';
      slider.parentNode.insertBefore(shell, slider);
      shell.appendChild(slider);
    }

    slides.forEach(function (slide, index) {
      slide.setAttribute('data-content-slide', String(index));
    });

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'content-slider__arrow content-slider__arrow--prev';
    prev.setAttribute('aria-label', 'Previous slide');

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'content-slider__arrow content-slider__arrow--next';
    next.setAttribute('aria-label', 'Next slide');

    var dots = document.createElement('div');
    dots.className = 'content-slider__dots';

    var dotButtons = slides.map(function (_, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'content-slider__dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
      dot.addEventListener('click', function () {
        scrollToSlide(slider, slides, index);
      });
      dots.appendChild(dot);
      return dot;
    });

    function updateControls() {
      var index = currentIndex(slider, slides);
      prev.disabled = index === 0;
      next.disabled = index === slides.length - 1;
      dotButtons.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    }

    prev.addEventListener('click', function () {
      scrollToSlide(slider, slides, Math.max(currentIndex(slider, slides) - 1, 0));
    });

    next.addEventListener('click', function () {
      scrollToSlide(slider, slides, Math.min(currentIndex(slider, slides) + 1, slides.length - 1));
    });

    slider.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateControls);
    }, { passive: true });

    shell.appendChild(prev);
    shell.appendChild(next);
    shell.appendChild(dots);
    updateControls();
  }

  function initAll(root) {
    toArray((root || document).querySelectorAll('.content-slider')).forEach(initContentSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
